import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ServiceTable = ({ 
  services = [], 
  onEdit, 
  onDuplicate,
  onDelete,
  onToggleStatus,
  selectedServices = [],
  onSelectService,
  onSelectAll
}) => {
  const allSelected = services?.length > 0 && selectedServices?.length === services?.length;
  const someSelected = selectedServices?.length > 0 && !allSelected;

  return (
    <div className="overflow-x-auto">
      <table className="w-full">
        <thead className="bg-muted border-b border-border">
          <tr>
            <th className="px-4 py-3 text-left w-12">
              <input
                type="checkbox"
                checked={allSelected}
                ref={input => {
                  if (input) input.indeterminate = someSelected;
                }}
                onChange={(e) => onSelectAll(e?.target?.checked)}
                className="w-4 h-4 rounded border-input text-primary focus:ring-2 focus:ring-ring focus:ring-offset-2 focus:ring-offset-background transition-smooth cursor-pointer"
                aria-label="Select all services"
              />
            </th>
            <th className="px-4 py-3 text-left text-sm font-caption font-medium text-muted-foreground">
              Service Name
            </th>
            <th className="px-4 py-3 text-left text-sm font-caption font-medium text-muted-foreground">
              Bookings
            </th>
            <th className="px-4 py-3 text-left text-sm font-caption font-medium text-muted-foreground">
              Status
            </th>
            <th className="px-4 py-3 text-right text-sm font-caption font-medium text-muted-foreground">
              Actions
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-border">
          {services?.map((service) => (
            <tr 
              key={service?.id}
              className="hover:bg-muted/50 transition-smooth"
            >
              <td className="px-4 py-4">
                <input
                  type="checkbox"
                  checked={selectedServices?.includes(service?.id)}
                  onChange={(e) => onSelectService(service?.id, e?.target?.checked)}
                  className="w-4 h-4 rounded border-input text-primary focus:ring-2 focus:ring-ring focus:ring-offset-2 focus:ring-offset-background transition-smooth cursor-pointer"
                  aria-label={`Select ${service?.name}`}
                />
              </td>
              <td className="px-4 py-4">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
                    <Icon name="Briefcase" size={20} color="var(--color-primary)" />
                  </div>
                  <div className="min-w-0">
                    <div className="font-medium text-foreground truncate">
                      {service?.name}
                    </div>
                    {service?.description && (
                      <div className="text-sm text-muted-foreground truncate max-w-xs">
                        {service?.description}
                      </div>
                    )}
                  </div>
                </div>
              </td>
              <td className="px-4 py-4">
                <div className="text-sm text-foreground">
                  {service?.booking_count || 0} total
                </div>
              </td>
              <td className="px-4 py-4">
                <button
                  onClick={() => onToggleStatus(service?.id, service?.is_available)}
                  className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium transition-smooth hover:opacity-80 ${
                    service?.is_available 
                      ? 'bg-success/10 text-success hover:bg-success/20' :'bg-muted text-muted-foreground hover:bg-muted/80'
                  }`}
                  title={`Click to set ${service?.is_available ? 'inactive' : 'active'}`}
                >
                  <span className={`w-1.5 h-1.5 rounded-full ${
                    service?.is_available ? 'bg-success' : 'bg-muted-foreground'
                  }`} />
                  {service?.is_available ? 'Active' : 'Inactive'}
                </button>
              </td>
              <td className="px-4 py-4">
                <div className="flex items-center justify-end gap-2">
                  <Button
                    variant="ghost"
                    size="icon"
                    onClick={() => onEdit(service)}
                    title="Edit service"
                    className="h-8 w-8"
                  >
                    <Icon name="Edit" size={16} />
                  </Button>
                  <Button
                    variant="ghost"
                    size="icon"
                    onClick={() => onDuplicate(service)}
                    title="Duplicate service"
                    className="h-8 w-8"
                  >
                    <Icon name="Copy" size={16} />
                  </Button>
                  <Button
                    variant="ghost"
                    size="icon"
                    onClick={() => onDelete(service?.id)}
                    title="Delete service"
                    className="h-8 w-8 text-destructive hover:text-destructive"
                  >
                    <Icon name="Trash2" size={16} />
                  </Button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ServiceTable;